module.exports = __webpack_public_path__ + "77fd28058103a634a690290fb4634efb.png";